export default "__VITE_ASSET__D8bISxfD__"